module.exports = __webpack_public_path__ + "svg/flags/Svalbard and Jan Mayen.svg";